import _ from 'lodash';

import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting, formValueSelector} from 'redux-form';

import Warning from 'components/Warning';
import {default as Modal, withModal} from 'components/Modal';
import {Buttons} from './components';

import LabelV2 from 'components/LabelV2';
import ValueOrInfinity from 'components/ValueOrInfinity';
import {SelectedRoomsReviewSection} from 'containers/RoomPurposes/components';

import {
  MODALS,
  getChangesBeforeCreatingRoomPurposes,
  PURPOSES
} from 'ducks/allocations';
import {formatDateForApi} from 'utils/datetime';
import './styles.css';

class ConfirmAssignRoomPurposeModal extends React.Component<any> {
  componentDidMount() {
    const {
      data: {selectedRooms, locationRef},
      form: {startDate, endDate, roomPurpose}
    } = this.props;

    this.props.getChangesBeforeCreatingRoomPurposes(
      {
        locationRef,
        rooms: selectedRooms.map(room => room.roomId),
        startDate: formatDateForApi(startDate),
        endDate: formatDateForApi(endDate),
        purpose: _.get(roomPurpose, 'value')
      },
      this.props.storeDataExtraActions(data => ({
        changesBeforeCreatingRoomPurposes: data
      }))
    );
  }

  onSubmit = () => {
    this.props.closeModal();

    this.props.submit('assignRoomPurpose');
  };

  getExistingRoomPurposesWithDifferentType = () => {
    const {
      data: {changesBeforeCreatingRoomPurposes},
      form: {roomPurpose}
    } = this.props;

    let existingRoomPurposesWithDifferentType: any = [];

    if (!_.isNil(changesBeforeCreatingRoomPurposes)) {
      const purposesForDeletionAndShrinking = _.flatten([
        changesBeforeCreatingRoomPurposes['forDeletion'],
        changesBeforeCreatingRoomPurposes['forShrinking']
      ]);

      existingRoomPurposesWithDifferentType = purposesForDeletionAndShrinking.filter(
        purposeWithDifferentType => {
          return (
            purposeWithDifferentType.purpose !== _.get(roomPurpose, 'value')
          );
        }
      );
    }
    return _.groupBy(existingRoomPurposesWithDifferentType, 'purpose');
  };

  getNotMatchingBookingTypes = () => {
    const {data: {changesBeforeCreatingRoomPurposes}} = this.props;

    let notMatchingBookings = [];

    if (!_.isNil(changesBeforeCreatingRoomPurposes)) {
      notMatchingBookings =
        changesBeforeCreatingRoomPurposes['notMatchingBookingTypes'];
    }

    return _.groupBy(notMatchingBookings, 'bookingType');
  };

  render() {
    const {
      form: {submitting, roomPurpose, startDate, endDate},
      data: {selectedRooms, roomsForRoomPurposesDashboard}
    } = this.props;

    const existingRoomPurposesWithDifferentType = this.getExistingRoomPurposesWithDifferentType();
    const notMatchingBookingTypes = this.getNotMatchingBookingTypes();

    return (
      <Modal
        show={true}
        type={Modal.SMALL}
        onClose={this.props.closeModal}
        className="ConfirmAssignRoomPurposeModal">
        <Modal.Header heading="Confirm Room Purpose" />
        <Modal.Body>
          <div className="room__section">
            {existingRoomPurposesWithDifferentType &&
              _.map(existingRoomPurposesWithDifferentType, (rooms, purpose) => (
                <Warning key={purpose}>
                  {`For rooms ${rooms.map(room => room.roomNumber).join(', ')}
                    there is an existing room purpose ${
                      PURPOSES[purpose]
                    } that will be shrinked or deleted!`}
                </Warning>
              ))}
            {notMatchingBookingTypes &&
              _.map(notMatchingBookingTypes, (rooms, bookingType) => (
                <Warning key={bookingType}>
                  {`For rooms ${rooms
                    .map((room: any) => room.roomNumber)
                    .join(', ')}
                    there are bookings with booking type ${bookingType} that does not correspond to the selected purpose type!`}
                </Warning>
              ))}

            <SelectedRoomsReviewSection
              roomsForRoomPurposesDashboard={roomsForRoomPurposesDashboard}
              selectedRooms={selectedRooms}
              isEditable={false}
            />
          </div>
          <div className="roomPurpose__section">
            <LabelV2>Room Purpose</LabelV2>
            {roomPurpose && <div> {roomPurpose.label}</div>}
          </div>
          <div className="roomPurpose__section">
            <LabelV2>Start date</LabelV2>
            <div>{startDate}</div>
          </div>
          <div className="roomPurpose__section">
            <LabelV2>End Date</LabelV2>
            <div>
              <ValueOrInfinity value={endDate} />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.onSubmit}
            submitting={submitting}
            onClose={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const formSelector = formValueSelector('assignRoomPurpose');

const mapStateToModalData = state => ({
  form: {
    submitting: isSubmitting('assignRoomPurpose')(state),
    roomPurpose: formSelector(state, 'roomPurpose'),
    startDate: formSelector(state, 'startDate'),
    endDate: formSelector(state, 'endDate')
  }
});

const mapDispatchToProps = {
  submit,
  getChangesBeforeCreatingRoomPurposes
};

export default connect(mapStateToModalData, mapDispatchToProps)(
  withModal(MODALS.CONFIRM_ASSIGN_ROOM_PURPOSE)(ConfirmAssignRoomPurposeModal)
);
